import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ backgroundColor: 'background.default', height: '100%' }}>
      <Container
        maxWidth="md"
        sx={{
          px: 5,
          py: 14,
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
        }}>
        <SentimentDissatisfiedIcon sx={{ color: 'text.secondary' }} />
        <Typography
          align="center"
          color="textPrimary"
          sx={{ my: 2 }}
          variant="h3">
          {t('common:404Page.title')}
        </Typography>
        <Typography align="center" color="textSecondary" variant="body2">
          {t('common:404Page.message')}
        </Typography>
        <Button
          color="primary"
          component={Link}
          sx={{ mt: 2 }}
          to="/"
          variant="outlinedContained">
          {t('common:404Page.takeMeHome')}
        </Button>
      </Container>
    </Box>
  );
};
